(function () {
  'use strict';

  if (window._mediaAutoplayInit) return;
  window._mediaAutoplayInit = true;

  var productSection = document.querySelector('[data-section-type="product"]');
  if (!productSection) return;

  function forcePlayVisibleVideos() {
    productSection
      .querySelectorAll('.product__media-item:not(.hidden) video.metafield-gallery-video')
      .forEach(function (video) {
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;

        video.load();

        setTimeout(function () {
          video.play().catch(function () {});
        }, 100);
      });

    productSection.querySelectorAll('.product__media-item.hidden video.metafield-gallery-video').forEach(function (video) {
      video.pause();
    });
  }

  forcePlayVisibleVideos();

  document.addEventListener('variant:change', function () {
    setTimeout(forcePlayVisibleVideos, 150);
  });

  document.addEventListener('product:variant-change', function () {
    setTimeout(forcePlayVisibleVideos, 150);
  });

  productSection.addEventListener('gallery:media-changed', function () {
    setTimeout(forcePlayVisibleVideos, 150);
  });
})();
